import { render, staticRenderFns } from "./AppGoldenGate.vue?vue&type=template&id=563f7724&scoped=true&"
import script from "./AppGoldenGate.vue?vue&type=script&lang=js&"
export * from "./AppGoldenGate.vue?vue&type=script&lang=js&"
import style0 from "./AppGoldenGate.vue?vue&type=style&index=0&id=563f7724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f7724",
  null
  
)

export default component.exports